import { signIn, confirmResetPassword } from 'aws-amplify/auth';

// Service overrides handed to the Amplify UI <Authenticator>.
//
// By default, Amplify UI v6 bounces a user back to the sign-in screen after
// a successful "forgot password" reset, forcing them to re-type the password
// they just chose. There's no built-in auto-sign-in for this flow, so we
// chain signIn() onto confirmResetPassword(). signIn() does establish a real
// Cognito session, but the Authenticator's internal state machine still
// routes back to the sign-in screen and ignores the new session
// (Hub.dispatch is unreliable here in v6, and useAuthenticator() isn't
// available from a `services` override). A full reload re-mounts the
// Authenticator against the now-authenticated session, which lands the user
// on whichever URL they originally requested. If the auto sign-in fails for
// any reason, the reset itself already succeeded, so we swallow the error
// and let the Authenticator fall through to its normal sign-in screen
// (no reload) so the user can sign in manually.
export const authServices = {
  async handleForgotPasswordSubmit(input) {
    await confirmResetPassword(input);
    try {
      await signIn({ username: input.username, password: input.newPassword });
      window.location.reload();
    } catch (error) {
      console.error('Auto sign-in after password reset failed: ', error);
    }
  },
};
